<script>import { getCtx, getAttrs } from "../ctx.js";
export let date;
export let asChild = false;
const {
  helpers: { isDateDisabled, isDateUnavailable }
} = getCtx();
$:
  attrs = {
    ...getAttrs("cell"),
    "aria-disabled": $isDateDisabled(date) || $isDateUnavailable(date),
    "data-disabled": $isDateDisabled(date) ? "" : void 0,
    role: "gridcell"
  };
</script>

{#if asChild}
	<slot {attrs} />
{:else}
	<td {...$$restProps} {...attrs}>
		<slot {attrs} />
	</td>
{/if}
